import * as React from "react";
import { UitkSheet, UitkSheetTransition } from "@egds/react-core/sheet";
import { FlightCardDefaultContent } from "components/flexComponents/Flights/components/FlightCardDefaultContent";
import { FlightsLink } from "typings/microserviceModels/flights-flex-module";

export interface MapFlightSheetProps {
  flight: FlightsLink;
  index: number;
  isVisible: boolean | undefined;
  isMobile: boolean | undefined;
}

export const MapFlightSheet = (props: MapFlightSheetProps) => {
  const { index, flight, isVisible, isMobile } = props;

  if (!isVisible) {
    return null;
  }

  return (
    <UitkSheetTransition isVisible={isVisible}>
      <UitkSheet className="MapFlightCard" isVisible={isVisible} triggerRef={null}>
        <FlightCardDefaultContent
          flight={flight}
          index={index}
          isMobile={isMobile === undefined ? true : isMobile}
          isTablet={false}
          showCityName={true}
        />
      </UitkSheet>
    </UitkSheetTransition>
  );
};

export default MapFlightSheet;
